module.exports = __webpack_public_path__ + "static/media/1005.c5e5c24e.jpg";